// extracted by mini-css-extract-plugin
export default {"rating":"aD-z","numberOfStars":"bD-z","count":"cD-z","barGraphSpacing":"dD-z","barGraph":"eD-z"};